module.exports = __webpack_public_path__ + "images/098f40f4ffa8e0406db29bc05a58a29f.webp";